import {Fragment, useEffect, useRef, useState} from 'react';
import {FaChevronDown, FaChevronUp} from "react-icons/fa";
import {GoDotFill} from "react-icons/go";
import {useLocation} from 'react-router-dom';
import SectionTitle from '../../../../components/SectionTitle/SectionTitle';
import './OfferSection.scss';
import {offerData} from './OfferData';

const OfferSection = () => {
  const { hash } = useLocation();
  const [expandedDetails, setExpandedDetails] = useState({});
  const [activeTab, setActiveTab] = useState('usg');
  const tabsRef = useRef(null);
  const sectionRef = useRef(null);
  const ALWAYS_EXPANDED_TABS = ['weekend-z-pediatra'];
  const scrollWithOffset = (element, offset) => {
    const elementPosition = element.getBoundingClientRect().top;

    const offsetPosition = elementPosition + window.pageYOffset - offset;
    
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  };
  
  useEffect(() => {
    if (hash) {
      const cleanHash = hash.substring(1);

      const tabMatch = offerData.find(tab => 
        tab.target.toLowerCase().includes(cleanHash.toLowerCase())
      );
      
      if (tabMatch) {
        setActiveTab(tabMatch.target);
        setTimeout(() => {
          if (tabsRef.current) {
            const offset = window.innerWidth < 992 ? 130 : 150;
            const width = window.innerWidth < 769;
            scrollWithOffset(width ? tabsRef.current : sectionRef.current, offset);
          }

          const buttonElement = document.getElementById(tabMatch.id);
          if (buttonElement) {
            const offset = window.innerWidth < 992 ? 130 : 150;
            const width = window.innerWidth < 769;
            scrollWithOffset(width ? buttonElement : sectionRef.current, offset);
          }
        }, 300);
        
        return;
      }

      let foundTab = null;
      let foundService = null;

      for (const tab of offerData) {
        if (tab.content) {
          const service = tab.content.find(service => 
            service.expanded_id && 
            service.expanded_id.toLowerCase().replace(/\s+/g, '-') === cleanHash.toLowerCase()
          );
          
          if (service) {
            foundTab = tab;
            foundService = service;
            break;
          }
        }
      }

      if (foundTab && foundService) {
        setActiveTab(foundTab.target);

        setExpandedDetails(prev => ({
          ...prev,
          [foundService.expanded_id]: true
        }));
        
        setTimeout(() => {
          const element = document.getElementById(foundService.expanded_id);
          if (element) {
            const offset = window.innerWidth < 992 ? 130 : 150;
            scrollWithOffset(element, offset);
          }
        }, 300);
      }
    }
  }, [hash]);

  const toggleDetails = (serviceId) => {
    setExpandedDetails(prev => ({
      ...prev,
      [serviceId]: !prev[serviceId]
    }));
  };

  return (
    <section className='offer-section section-pt' data-aos="fade-up" data-aos-duration="1000">
      <div className="container">
        <div className="title-container section-m section-pt">
          <SectionTitle title="Kompleksowa diagnostyka i nowoczesne metody leczenia" />
          <p className='section-title-text'>
            Witamy w naszej placówce! Oferujemy Naszym Pacjentom szeroki zakres badań diagnostycznych,
            konsultacji specjalistycznych oraz nowoczesnych zabiegów regeneracyjnych <br /> i przeciwbólowych.
            W trosce o Wasze zdrowie wykorzystujemy najnowocześniejszy sprzęt oraz doświadczenie naszych lekarzy.
          </p>
          <p className='section-title-text bg-text'>Na każdą wizytę sugerujemy zabrać ze soba dotychczasowe wyniki badań oraz historię choroby (również opisy i zdjęcia), gdyż umożliwia to poprawną interpretację dynamiki zmian.</p>
        </div>
        <div  ref={sectionRef}  className='instruction-container section-mt'>
        <p className='section-title-text'>
            Kliknij na wybraną kategorię, aby zobaczyć szczegóły.
          </p>
        </div>
        <div className="offer-tabs d-flex align-items-start">
          <div className="nav flex-column nav-pills me-md-4" id="v-pills-tab" role="tablist" aria-orientation="vertical">
            {offerData.map((item) => (
              <button 
                key={item.id} 
                className={`tab-button nav-link ${activeTab === item.target ? 'active' : ''}`} 
                id={item.id} 
                data-bs-toggle="pill" 
                data-bs-target={`#${item.target}`} 
                type="button" 
                role="tab" 
                aria-controls={item.target} 
                aria-selected={activeTab === item.target}
                onClick={() => setActiveTab(item.target)}
              >
                {item.title}
              </button>
            ))}
          </div>
          <div className="tab-content" id="v-pills-tabContent">
            {offerData.map((item) => (
              <div
                key={item.id} 
                className={`tab-pane fade ${activeTab === item.target ? 'show active' : ''}`} 
                id={item.target} 
                role="tabpanel" 
                aria-labelledby={item.id} 
                tabIndex="0"
              >
                <div className="row">
                  {item.img && (
                    <div className="col-lg-4 mb-4">
                      <img src={item.img} alt={item.title} className="tab-image" />
                    </div>
                  )}
                  <div className={item.img ? 'col-lg-8' : 'col-lg-12'}>
                    {item.tabTitle && <p className="tab-description">
                      {item.tabTitle}
                    </p>}
                    <div className="service-list">
                      {item.content && item.content.map((service) => {
  const isAlwaysExpanded = ALWAYS_EXPANDED_TABS.includes(service.expanded_id);
  
  return (
    <Fragment key={service.title}>
      <div 
        onClick={() => !isAlwaysExpanded && toggleDetails(service.expanded_id)} 
        className={`service-item ${isAlwaysExpanded ? 'always-expanded' : ''}`}
        id={service.expanded_id} 
      >
        <GoDotFill className='service-icon' />
        <span className="service-text">{service.title}</span>
        {service.expanded_id && !isAlwaysExpanded && (
          <div className="details-toggle">
            {expandedDetails[service.expanded_id] ? <FaChevronUp /> : <FaChevronDown />}
          </div>
        )}
      </div>
      {service.expanded_id && (isAlwaysExpanded || expandedDetails[service.expanded_id]) && (
        <div className="service-details">
          {service.expanded_content}
        </div>
      )}
    </Fragment>
  );
})}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OfferSection;
//   const changeActiveTab = (hash) => {
//     const mainTabs = document.querySelectorAll('.tab-button.nav-link');
//     const allPanes = document.querySelectorAll('.tab-pane');
   
//     const tabIndex = hashToTabIndex[hash];
//     if (typeof tabIndex === 'number') {
//       allPanes.forEach(pane => pane.classList.remove('show', 'active'));

//       mainTabs.forEach(tab => {
//         tab.classList.remove('active');
//       })
//     const tabToActivate = mainTabs[tabIndex];
//     const paneToActivate = allPanes[tabIndex];
//     if (tabToActivate) tabToActivate.classList.add('active');
//     if (paneToActivate) paneToActivate.classList.add('show', 'active');
//   }
// console.log(hash)
//     if (hash === '#suche-iglowanie') {
//       toggleDetails('Zabieg suchego igłowania');
//     } else if (hash === '#leczenie_ortobiologiczne') {
//       toggleDetails('Leczenie ortobiologiczne');
//     }
//   }
//     useEffect(() => {
//       if (hash) {;
//         changeActiveTab(hash);
//         setTimeout(() => {
//           const element = document.querySelector(decodeURIComponent(hash));
//           console.log('element', element)
//                   if (element) {
//                       const offset =130;
//                       const elementPosition = element.getBoundingClientRect().top + window.scrollY;
//                       window.scrollTo({
//                           top: elementPosition - offset,
//                           behavior: 'smooth'
//                       });
//                   }
//               }, 300);
//           }
  //       }, [hash]);
  